import Controller from '../abstracts/Controller';

/**
 * Controller for page Myaccount Orders
 */
export default class MyAccountPrivacyController extends Controller {
  static get COMPONENTS(){
    return ['CollapseComponent','PrivacyUnsubscribe'];
  }

}